import type { SxProps } from '@portals/core/src/themes/themes';

export const getStyles = (): { [key: string]: SxProps } => {
  return {
    container: {
      transitionDuration: '400ms',
      transitionDelay: '3s',
      transitionTimingFunction: 'ease-in-out',
      transitionProperty: 'max-height',
      overflow: 'hidden',
    },
  };
};
